import { createContext, useContext } from "react";

import { Media } from "../types/player-api";

export const MediaContext = createContext<Media | undefined>(undefined);

export const useMediaContext = (): Media => {
  const context = useContext(MediaContext);
  if (context === undefined) {
    throw new Error("MediaContext not found");
  }
  return context;
};
